import React from "react";
interface ProcessStepProps {
  icon: React.ReactNode;
  title: string;
  showArrow: boolean;
  isActive?: boolean;
  index: number;
}
export function ProcessStep({
  icon,
  title,
  showArrow,
  isActive = false,
  index,
}: ProcessStepProps) {
  const isEven = index % 2 === 0;
  return (
    <>
      {/* Desktop/Large Tablet view - horizontal layout */}
      <div className="hidden lg:flex flex-col items-center w-32 sm:w-36 mb-8 relative">
        <div
          className={`mb-3 transition-transform duration-300 ${
            isActive ? "scale-110" : "scale-100"
          }`}
        >
          {icon}
        </div>
        <div className="text-center text-green-600 font-medium leading-tight text-sm sm:text-base max-w-[160px]">
          {title}
        </div>
        {showArrow && (
          <div className="absolute left-full top-1/2 -translate-y-8 items-center w-8 flex">
            <div className="h-0.5 bg-green-600 w-4"></div>
            <div className="w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-l-[8px] border-l-green-600"></div>
          </div>
        )}
      </div>
      {/* Mobile/Tablet view - vertical timeline */}
      <div className="lg:hidden flex w-full relative mb-12 sm:mb-16">
        {/* Timeline center line */}
        <div className="absolute left-1/2 transform -translate-x-1/2 top-0 h-full w-0.5 bg-green-600"></div>
        {/* Content container */}
        <div
          className={`flex w-full items-center ${
            isEven ? "flex-row" : "flex-row-reverse"
          }`}
        >
          {/* Content side */}
          <div
            className={`w-1/2 px-2 ${
              isEven
                ? "text-right pr-4 sm:pr-6 md:pr-8"
                : "text-left pl-4 sm:pl-6 md:pl-8"
            }`}
          >
            <div className="text-green-600 font-medium leading-tight text-sm sm:text-base md:text-lg mb-1 sm:mb-2">
              {title}
            </div>
          </div>
          {/* Icon in the middle */}
          <div className="relative z-10">
            <div
              className={`bg-white rounded-full p-1 sm:p-1.5 md:p-2 border-2 border-green-600 transition-all duration-300 
                ${isActive ? "animate-pulse-soft scale-110" : "scale-100"}`}
            >
              <div className="transform scale-75 sm:scale-80 md:scale-90">
                {icon}
              </div>
            </div>
            {/* Arrow for next step */}
            {showArrow && (
              <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-8 sm:-bottom-10 flex justify-center">
                <div className="text-green-600">
                  <div className="h-6 sm:h-8 w-0.5 bg-green-600 mx-auto"></div>
                  <div className="w-0 h-0 border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[6px] border-t-green-600 mx-auto"></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
